import React from 'react';

import { ErrorCard } from '@eika/card';

import { DebitCardOrderStatus } from '@generated-types';
import useText from '@hooks/use-text';

const SigningOrderErrorView = ({ cardOrderStatus }: { cardOrderStatus: DebitCardOrderStatus | undefined | null }) => {
    const { signingOrderFailedError, signingOrderMissingError } = useText();

    const getDescription = () => {
        if (cardOrderStatus == null || typeof cardOrderStatus === 'undefined') return signingOrderMissingError;

        if (cardOrderStatus === DebitCardOrderStatus.CANCELLED) return 'Signering av dokumentet er avbrutt.';

        return signingOrderFailedError;
    };

    return <ErrorCard title="" description={getDescription()} />;
};

export default SigningOrderErrorView;
